
import dayjs from 'dayjs'
import { commonfunc } from '~/mixin/common.js'

export default {
  name: 'HeaderNavigations',
  mixins: [
    commonfunc
  ],
  props: {
    navigationsData: {
      type: Array,
      default: () => []
    },
    currentMall: {
      type: String,
      default: null
    },
  },
  methods: {
    goHome () {
      if (this.$route.path === '/ds') {
        this.$router.go(this.$router.currentRoute)
      } else {
        this.$router.push({ path: '/ds' })
      }
      sessionStorage.setItem('filterCheck', [])
      sessionStorage.setItem('prodSortCheck', '')
    },
  }
}
